module.exports = __webpack_public_path__ + "img/status-paid.b5afd17b.svg";